import React from 'react';
import { Star, CheckCircle2 } from 'lucide-react';
export function TestimonialsV2() {
  const testimonials = [{
    name: 'María T.',
    country: 'México',
    headline: 'Día 3 — Por fin pude pasear sin tirones',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=faces'
  }, {
    name: 'Roberto G.',
    country: 'Chile',
    headline: 'El elevador ya no es un campo de batalla',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces'
  }, {
    name: 'Carmen L.',
    country: 'Chile',
    headline: 'Caminata relajada en medio del parque',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=faces'
  }];
  return <section className="py-10 px-4 bg-brand-teal" data-id="element-289">
      <div className="max-w-6xl mx-auto" data-id="element-290">
        <div className="text-center mb-8" data-id="element-291">
          <h2 className="text-3xl md:text-4xl font-bold font-serif text-white mb-6" data-id="element-292">
            Lo que dicen quienes ya recuperaron la calma en sus paseos
          </h2>
          <div className="inline-flex items-center justify-center bg-brand-teal-dark border border-white/10 rounded-full px-6 py-2" data-id="element-293">
            <span className="text-white font-bold mr-2" data-id="element-294">4.9</span>
            <div className="flex mr-3" data-id="element-295">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-brand-gold fill-brand-gold" data-id="element-296" />)}
            </div>
            <span className="text-teal-100 text-sm" data-id="element-297">
              +8,500 dueños registrados
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-298">
          {testimonials.map((t, idx) => <div key={idx} className="bg-brand-teal-dark border border-white/20 rounded-[20px] p-8 flex flex-col" data-id="element-299">
              <div className="flex items-center gap-4 mb-6" data-id="element-300">
                <img src={t.image} alt={t.name} className="w-14 h-14 rounded-full object-cover border-2 border-brand-gold" data-id="element-301" />
                <div data-id="element-302">
                  <div className="flex items-center gap-1.5" data-id="element-303">
                    <p className="font-bold text-white text-lg" data-id="element-304">{t.name}</p>
                    <CheckCircle2 className="w-4 h-4 text-green-400" data-id="element-305" />
                  </div>
                  <p className="text-sm text-teal-200 uppercase tracking-wide" data-id="element-306">
                    {t.country}
                  </p>
                </div>
              </div>
              <div className="flex mb-4" data-id="element-307">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-brand-gold fill-brand-gold" data-id="element-308" />)}
              </div>
              <h4 className="text-white font-serif text-xl italic leading-relaxed" data-id="element-309">
                "{t.headline}"
              </h4>
            </div>)}
        </div>
      </div>
    </section>;
}